import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '../../../store';
import { ChatProps } from '../../communities/components/Chats/interface/chats.interface';

interface State {
    current?: null | ChatProps;
}

const initialState: State = {
    current: null,
};

export const analyticSelectorSlice = createSlice({
    name: 'analyticSelector',
    initialState,
    reducers: {
        resetCurrentChat: () => initialState,
        setCurrentChat: (state, action) => {
            state.current = action.payload;
        },
    },
});

export const { setCurrentChat, resetCurrentChat } =
    analyticSelectorSlice.actions;

export const selectAnalyticsSelection = (state: RootState) =>
    state.analyticSelector;

export const analyticSelectorReducer = analyticSelectorSlice.reducer;
